function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWedge = function SvgWedge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M17.473 5.908c1.176-1.987.319-4.222-1.915-4.959 0 0-2.864-.949-6.712-.949S2.454.86 2.454.86C.219 1.58-.656 3.798.529 5.785L6.895 16.51c1.176 1.987 3.11 1.987 4.285 0l6.293-10.593v-.009Z"
  }));
};
export default SvgWedge;